import { render, staticRenderFns } from "./Activity_live_news.vue?vue&type=template&id=0563207d"
import script from "./Activity_live_news.vue?vue&type=script&lang=js"
export * from "./Activity_live_news.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports